import { useParams, Link } from 'react-router-dom';
import SEOHead from '@/components/base/SEOHead';
import Breadcrumb from '@/components/base/Breadcrumb';
import VideoCard from '@/components/feature/VideoCard';
import CategoryTabs from '@/components/feature/CategoryTabs';
import { categories, categorySlugMap } from '@/mocks/categories';
import { getArticlesByCategory } from '@/mocks/articles';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const categoryName = categorySlugMap[slug || ''] || '分类';
  const category = categories.find((c) => c.slug === slug);
  const articles = getArticlesByCategory(slug || '');

  return (
    <>
      <SEOHead
        title={`${categoryName} - 分类浏览`}
        description={category?.description || `久久视频${categoryName}分类，高清在线观看，海量精彩内容尽在久久视频。`}
        keywords={`久久视频,${categoryName},久久视频${categoryName},久久视频${categoryName}在线观看`}
        canonicalUrl={`/category/${slug}`}
      />

      <main className="pt-20 pb-10">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: categoryName },
            ]}
          />

          <div className="mb-6">
            <CategoryTabs />
          </div>

          <section className="mb-8">
            <div className="flex items-center gap-3 mb-2">
              {category && (
                <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-50 text-primary-500">
                  <i className={`${category.icon} text-lg`}></i>
                </span>
              )}
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                {categoryName}
              </h1>
              {category && (
                <span className="text-sm text-foreground-500">({category.articleCount}个内容)</span>
              )}
            </div>
            {category && (
              <p className="text-foreground-600 text-sm max-w-2xl">{category.description}</p>
            )}
          </section>

          {articles.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {articles.map((article) => (
                <VideoCard key={article.id} article={article} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <span className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-background-100 text-foreground-400 mb-4">
                <i className="ri-inbox-line text-2xl"></i>
              </span>
              <p className="text-foreground-500">该分类暂无内容</p>
              <Link to="/" className="text-sm text-primary-500 hover:text-primary-600 mt-2 inline-block">
                返回首页
              </Link>
            </div>
          )}
        </div>
      </main>
    </>
  );
}